import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasPermission } from "utils/permissionHelper";

const Authmiddleware = ({ children, module, permission }) => {
  const { permissions, loading } = useSelector(state => state.permissions);

  // Not logged in
  if (!localStorage.getItem("authUser")) {
    return <Navigate to="/login" replace />;
  }

  // Wait only first time
  if (loading && !permissions) {
    return <div>Loading...</div>;
  }

  // Permission check
  if (module && permission && !hasPermission(permissions || {}, module, permission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default Authmiddleware;